module.exports = __webpack_public_path__ + "static/media/level-complete.080c26f4.svg";